import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import {AnnouncementService} from "../../_admin/announcements/services/announcement.service";
import {AnnouncementDTO} from "../../_admin/announcements/models/AnnouncementDTO";
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-announcement-widget',
    templateUrl: './announcement-widget.component.html',
    styleUrls: ['./announcement-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnnouncementWidgetComponent {
  announcements: AnnouncementDTO[] | undefined;
  maxLengthWidget = 200;
  @Output() isLoading = new EventEmitter<boolean>(true);
  isMobile = false;
  readonly containerName = environment.containerAnnouncementName;
constructor(private announcementService: AnnouncementService) {
  this.isLoading.emit(true);
  this.announcementService.GetUserAnnouncements().subscribe( data => {
    this.announcements = data;
    this.isLoading.emit(false);
  } );
  this.isMobile = window.innerWidth <= 768;
}
}
